// libs/react-mosaic-component/src/lib/internalTypes.ts
var MosaicDropTargetPosition = {
  TOP: "top",
  BOTTOM: "bottom",
  LEFT: "left",
  RIGHT: "right"
};
export {
  MosaicDropTargetPosition
};
